module.exports = __webpack_public_path__ + "6a6965aa5844c50e280a4022895750b9.png";